import {ItemToolEditor} from "./CreatePriceGroup.jsx";
export default function CreateTax(props){return <ItemToolEditor {...props} kind="tax"/>;}
